import React from 'react'
import { RingLoader } from 'react-spinners'

interface SpinnerProps {
  color?: string
  loading: boolean
}

const Spinner: React.FC<SpinnerProps> = ({ color = '#000', loading }) => {
  if (!loading) return null

  return (
    <div className="flex items-center justify-center">
      <RingLoader color={color} loading={loading} size={20} /> {/* ↓ size */}
    </div>
  )
}


export default Spinner
